import { render } from "./CommunitySettings.vue.js?vue&type=template&id=bc30f2a0!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CommunitySettings.vue?vue&type=template&id=bc30f2a0"
import script from "./CommunitySettings.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CommunitySettings.vue?vue&type=script&lang=js"
export * from "./CommunitySettings.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CommunitySettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/community/CommunitySettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bc30f2a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bc30f2a0', __exports__)) {
    api.reload('bc30f2a0', __exports__)
  }
  
  module.hot.accept("./CommunitySettings.vue.js?vue&type=template&id=bc30f2a0!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CommunitySettings.vue?vue&type=template&id=bc30f2a0", () => {
    api.rerender('bc30f2a0', render)
  })

}


export default __exports__